<template>
  <div class="layout-inner">
    Loading..
  </div>
</template>

<script>
  export default {
    name: 'redirectToWeb',
    props: [],
    components: {
    },
    data: () => {
      return {
      }
    },
    mounted () {
      window.location.href = '/frontend/#/widget/register'
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/login/components/RedirectToWeb.vue